import React from 'react';
import type { ItemSidebarComponentFeatureType } from '../types';
import { Ad } from '../../../ads/ad';

const FeatureAd: React.FC<ItemSidebarComponentFeatureType> = ({ data }) => {
  return <Ad className={data?.data?.data?.config.container} desktopOnly />;
};

export default FeatureAd;
